import { NotificationType } from "./notificationTypes";
import { AlertCircle, AlertTriangle, CheckCircle } from "lucide-react";

export const NotificationsIconClass = {
    [NotificationType.None]: 'green',
    [NotificationType.Success]: 'green',
    [NotificationType.Error]: 'red',
    [NotificationType.Warning]: 'orange',
    [NotificationType.Information]: 'blue',
    [NotificationType.Question]: null,
}

export const NotificationsIcons = {
    [NotificationType.None]: null,
    [NotificationType.Error]: AlertTriangle,
    [NotificationType.Information]: AlertCircle,
    [NotificationType.Success]: CheckCircle,
    [NotificationType.Warning]: AlertCircle,
    [NotificationType.Question]: null,
};